import styled from "@emotion/styled";
import theme from "@theme";
import InnoIcons from "InnoUI/innoicons";

const LeasingLayout = styled.div`
  margin-top: 50px;
  border-bottom: 1px solid ${theme.colors.bordertask};
`;

const BodyHeader = styled.div`
  padding: 12px 20px;
  background-color: #f7f9f7;
  border-bottom: 1px solid ${theme.colors.bordertask};
  position: fixed;
  width: 100%;
  z-index: 1000;
`;

const Container = styled.div``;

const HeadingTag = styled.p`
  float: left;
  margin: 5px;
  padding: 0px 20px 0px 0px;
  font-weight: bold;
`;
const ValueSpanP = styled.span`
  color: ${theme.colors.black};
  font-size: 13px;
  opacity: 0.7;
  cursor: pointer;
`;
const ValueSpan = styled.span`
  color: ${theme.colors.black};
  font-size: 13px;
  opacity: 0.7;
  cursor: pointer;
`;

const PopoverContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const PopoverSpan = styled.span`
  background-color: #f3f3f3;
`;

const MoreVertIcon = styled(InnoIcons.MoreVertIcon)`
  font-size: 15px;
  cursor: pointer;
  margin: 5px 0px 5px 0px;
  background-color: #f3f3f3;
`;

const TabDiv = styled.div`
  display: flex;
  gap: 20px;
  flex: 0.5;
  padding: 0px 8px;
  margin: 0px 20px 0px 20px;
  align-items: baseline;
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  background: #ffffff;
  border: 1px solid ${theme.colors.bordertask};
  border-radius: 8px;
  padding: 4px;
  gap: 0px;
  width: fit-content;
`;

const CartTabButton = styled.button`
  min-width: 150px;
  height: 33px;
  border: 0;
  border-radius: 5px;
  background: ${({ active }) =>
    active ? theme.gradient.themeGradient : "transparent"};
  color: ${({ active }) => (active ? theme.colors.white : theme.colors.black)};
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  padding: 0px 14px;
  transition:
    background 0.2s ease,
    color 0.2s ease,
    box-shadow 0.2s ease;

  &:hover {
    color: ${({ active }) =>
      active ? theme.colors.white : theme.colors.themeColor};
  }
`;

const HeaderStyle = styled.div`
  font-size: 15px;
  font-weight: 500;
  color: #333333;
`;

const CountStyle = styled.span`
  font-size: 12px;
  font-weight: bold;
  color: ${theme.colors.themeColor};
  margin-bottom: 10px;
`;

const DrawerTitlesContainer = styled.div`
  display: flex;
  background: ${theme.gradient.themeGradient};
  align-items: center;
  justify-content: space-between;
  padding: 0px 10px 0px 20px;
  height: 50px;
  position: sticky;
  top: 0;
  z-index: 1000;
`;

const CloseIcon = styled.p`
  cursor: pointer;
  color: white;
`;

const DrawerTitles = styled.span`
  font-size: 17px;
  color: white;
  font-weight: normal;
`;

const SearchIcon = styled(InnoIcons.SearchIcon)`
  position: absolute;
  left: 10px;
  color: #afafaf;
  font-size: 20px;
`;

const InputContiner = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: 500px;
  height: 50px;
`;

const InputStyle = styled.input`
  width: 100%;
  height: 30px;
  padding: 8px 8px 8px 35px;
  font-size: 13px;
  border: 1px solid ${theme.colors.themeColor};
  border-radius: 5px;
  &:focus {
    outline: none;
    border-color: #ccc;
  }
  &::placeholder {
    color: #afafaf;
  }
`;

const SC = {
  Container,
  BodyHeader,
  HeadingTag,
  ValueSpan,
  MoreVertIcon,
  PopoverSpan,
  PopoverContainer,
  ValueSpanP,
  LeasingLayout,
  HeaderContainer,
  CartTabButton,
  HeaderStyle,
  CountStyle,
  TabDiv,
  DrawerTitlesContainer,
  CloseIcon,
  DrawerTitles,
  SearchIcon,
  InputContiner,
  InputStyle,
};

export default SC;
